define('plugin/classes/collection/ClassesPluginCollection',['require','lib/collection/BaseCollection','plugin/classes/model/ClassesPluginModel','model/TimeSlotModel','backbone','Config'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var ClassesPluginModel = require('plugin/classes/model/ClassesPluginModel');
    var TimeSlotModel = require('model/TimeSlotModel');

    var Backbone = require('backbone');
    var Config = require('Config');

    /**
     * Classes collection
     *
     * @class ClassesCollection
     */
    return BaseCollection.extend({

        url: '/booking/classes-plugin/',
        model: ClassesPluginModel,
        _timeCollection: new Backbone.Collection(),
        _providerCollection: new Backbone.Collection(),

        /**
         * Returns collection of available timeslots
         *
         * @return {Backbone.Collection}
         */
        getTimeCollection: function (diff) {
            var min = null;
            var max = null;
            var date = null;
            var timeframe  = Config.getInstance().getTimeFrame();
            this.each(function (model) {
                if (!model.get('slots')) {
                    return;
                }
                model.get('slots').each(function (slot) {
                    var time = new Time(slot.get('client_time'));

                    var startTime = time.getInteger();
                    var endTime = time.getInteger() + (slot.get('slots_count') * timeframe);

                    if (max === null || endTime > max) {
                        max = endTime;
                    }
                    if (min === null || startTime < min) {
                        min = startTime;
                    }

                    date = slot.get('client_date');
                });
            });

            this._buildTimeCollection(min, max, date);

            return this._timeCollection;
        },

        /**
         * Builds available time slots
         *
         * @param Integer from
         * @param Integer to
         * @param String date
         * @private
         */
        _buildTimeCollection: function (from, to, date) {
            var timeframe = Config.getInstance().getTimeFrame();

            var models = [];
            for (var slot = from; slot < to; slot += timeframe) {
                var time = new Time(slot);
                var timeStr = time.getFormattedTime('24hr');

                models.push(new TimeSlotModel({
                    'id': date + ' ' + timeStr,
                    'time': timeStr,
                    'date': date
                }));
            }
            this._timeCollection.reset(models);
        }

    });

});
